import React from "react";
import { Container } from "./TransparentLineV2.style";

const TransparentLineV2 = () => {
    return <Container />;
};

export default TransparentLineV2;
